import script from "./ProductCSV.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProductCSV.vue?vue&type=script&lang=ts&setup=true"

import "./ProductCSV.vue?vue&type=style&index=0&id=eeb81768&lang=scss&scoped=true"

import exportComponent from "/home/kenddriz/Public/locaa/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eeb81768"]])

export default __exports__